import moment from "moment";
import { store } from "../store";

/**
 * Service class for general utility operations and UI state management
 */
export class UtilityService {
  static updateSnackbarMessage(message, error = false) {
    let severity = "success";

    //lowercase message and check for error
    if (message.toLowerCase().includes("error") || error === true) {
      severity = "error";
    }

    // Add notification to queue instead of updating single state
    store.dispatch({
      type: "snackbar/add",
      payload: {
        message: message,
        severity: severity,
      },
    });
  }

  static handleSnackbarClose(notificationId = null) {
    if (notificationId) {
      // Remove specific notification
      store.dispatch({
        type: "snackbar/remove",
        payload: { id: notificationId },
      });
    } else {
      // Legacy support - remove first notification
      store.dispatch({
        type: "snackbar/close",
      });
    }
  }

  static clearSnackbarQueue() {
    store.dispatch({
      type: "snackbar/clear",
    });
  }

  static updateThemeMode(themeMode) {
    return store.dispatch({ type: "themeMode/update", payload: themeMode });
  }

  static updateDateRange(startDateUnix, endDateUnix) {
    //if either are empty, generate a new date range
    if (!startDateUnix || !endDateUnix) {
      //start date, 24 hours ago in unix timestamp
      startDateUnix = moment().utc().subtract(24, "hours").unix();
      //end date, now in unix timestamp
      endDateUnix = moment().utc().unix();
    }

    //check if start date and end date are unix timestamps, if not, convert them
    if (startDateUnix._isAMomentObject) {
      startDateUnix = startDateUnix.unix();
    }

    if (endDateUnix._isAMomentObject) {
      endDateUnix = endDateUnix.unix();
    }

    store.dispatch({
      type: "dateRange/update",
      payload: {
        startDate: startDateUnix,
        endDate: endDateUnix,
      },
    });
  }
}
